import { type PropsWithChildren } from 'react';

import type { BehaviorTrackingProps } from '../../core/types/behavior-tracking-props.js';
import { DataTestId } from '../../core/types/data-props.js';
import { StylingProps } from '../../core/types/styling-props.js';

/**
 * Props for the SelectGroupLabel component.
 * @public
 */
export type SelectGroupLabelProps = PropsWithChildren<unknown> &
  StylingProps &
  DataTestId &
  BehaviorTrackingProps;

/**
 * `Select.GroupLabel` defines the label of an option group. The component
 * is only valid within a `Select.Group`.
 *
 * @example
 * ```tsx
 * <Select.Group>
 *   <Select.GroupLabel>Colors</Select.GroupLabel>
 *   <Select.Option value="red">Red</Select.Option>
 *   <Select.Option value="green">Green</Select.Option>
 * </Select.Group>
 * ```
 * @public
 */
export function SelectGroupLabel(props: SelectGroupLabelProps) {
  return null;
}

/**
 * Props for the SelectGroup component
 * @public
 */
export type SelectGroupProps = PropsWithChildren<unknown> &
  StylingProps &
  DataTestId &
  BehaviorTrackingProps;

/**
 * `Select.Group` defines a group of options that share some commonalities.
 * The component is only valid within a `Select.Content` element.
 *
 * @example
 * ```tsx
 * <Select.Content>
 *   <Select.Group>
 *     <Select.GroupLabel>Colors</Select.GroupLabel>
 *     <Select.Option value="red">Red</Select.Option>
 *     <Select.Option value="green">Green</Select.Option>
 *   </Select.Group>
 * </Select.Content>
 * ```
 * @public
 */
export function SelectGroup(props: SelectGroupProps): null {
  return null;
}
